import React from 'react';
const stats = [{
  value: '12 months',
  label: 'Mapped month by month'
}, {
  value: '6 + 5',
  label: 'Volumes and field tools'
}, {
  value: '200+',
  label: 'Decisions, already in order'
}, {
  value: 'End to end',
  label: 'From “yes” to the morning after'
}];
export function SocialProofBar() {
  return <section aria-label="What the system covers" className="w-full bg-ink" data-id="element-194" data-mp="25tn9vwl79mu3">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-8 sm:py-10" data-id="element-195" data-mp="32iut2xycjjuu">
        <dl className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-7" data-id="element-196" data-mp="32h0h4951z22w">
          {stats.map(stat => <div key={stat.label} className="text-center" data-id="element-197" data-mp="2xi76qpl2br6y">
              <dt className="font-serif font-normal text-white text-[22px] sm:text-[26px] leading-none" data-id="element-198" data-mp="2th3sg7iny37u">
                {stat.value}
              </dt>
              <dd className="mt-2 text-[12px] uppercase tracking-kicker text-white/65" data-id="element-199" data-mp="1i2zxoz494b1q">
                {stat.label}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}